import { withInstall } from '@antdv/utils';
import AEmpty from './src/Empty';

export const Empty = withInstall(AEmpty);

export default Empty;

export * from './src/props';
